export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10">
            <p className="text-xs md:text-sm font-medium text-secondary-500 uppercase tracking-wide mb-2">关于我们</p>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">关于糖心视频</h2>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <div className="prose max-w-none">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                糖心视频网创立于2024年，致力于为广大影视爱好者打造一站式的免费在线观影平台。我们聚合西瓜视频、樱花视频、糖豆视频、樱桃视频等国内主流视频平台的海量资源，涵盖最新电影、热播电视剧、人气综艺、高分纪录片、番剧动漫等全品类内容。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                糖心视频秉持"开放聚合、免费共享"的理念，通过技术手段打通各平台内容壁垒，让用户无需在多个APP之间切换，即可畅享全网热门影视资源。我们坚持每日更新，确保热播内容第一时间上线，为用户提供流畅、高清的观影体验。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                目前糖心视频日均服务用户超过500万，累计收录影视作品超50万部，涵盖30余个内容品类。未来我们将持续优化产品体验，拓展更多优质内容源，努力成为国内领先的影视资源聚合平台。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
              {[
                { num: '500万+', label: '日活用户' },
                { num: '50万+', label: '影视资源' },
                { num: '10+', label: '内容平台' },
                { num: '3000+', label: '日更新量' },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-4 rounded-xl bg-background-50">
                  <p className="text-xl md:text-2xl font-bold font-heading text-primary-500">{stat.num}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}